

















import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "AvatarDescription",
  components: { BaseAvatar },
  props: {
    userPublicData: { type: Object as () => UserPublicData, required: true },
    avatarSize: { type: Number, default: 56 },
    title: { type: String },
    description: { type: String },
    to: Object as () => Location,
    borderBottom: { type: Boolean, default: false },
  },
});
